import {
  NodePricingInfo,
  ValueRenderType,
} from '../../../cost-report/components/NodePricingInfo';

import { NodeMetricsByType } from '../../_types';
import { Typography, Stack } from '@cast/design-system';

export const RequestedResourceCell = (props: NodeMetricsByType) => {
  const { total } = props;

  if (!total) {
    return (
      <Typography component="span" variant="inherit">
        -
      </Typography>
    );
  }
  return (
    <Stack width="100%">
      <Typography variant="P12R" noWrap>
        {total.toFixed(2)}
      </Typography>
      <NodePricingInfo
        {...props}
        progressBarSx={{ height: 4 }}
        sx={{ lineHeight: '4px' }}
        type={ValueRenderType.Plain}
        hideTotal
      />
    </Stack>
  );
};
